import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "auto pa-2" }
const _hoisted_2 = { class: "subtitle-1 text--dark" }
const _hoisted_3 = { style: {"margin":"0"} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "auto pa-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_splash_placeholder = _resolveComponent("splash-placeholder")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_favourite_icon = _resolveComponent("favourite-icon")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: "my-pointer ion-activatable",
    style: _normalizeStyle({
        'border-left':'6px solid rgb('+ _ctx.getColor(_ctx.article.category ? _ctx.article.category.name : '') + ')',
      })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_ripple_effect),
      _createVNode(_component_ion_grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                "size-sm": "6",
                "size-md": "4",
                "size-lg": "2",
                class: "flex"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.article.splash && _ctx.article.splash.formats)
                      ? (_openBlock(), _createBlock(_component_ion_img, {
                          key: 0,
                          src: _ctx.article.splash.formats.thumbnail.url,
                          alt: "splash"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (!_ctx.article.splash || !_ctx.article.splash.formats)
                      ? (_openBlock(), _createBlock(_component_splash_placeholder, {
                          key: 1,
                          height: "unset",
                          category: _ctx.article.category ? _ctx.article.category.name : ''
                        }, null, 8, ["category"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                "size-sm": "5",
                "size-md": "7",
                "size-lg": "9"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.article.title), 1),
                  _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.article.subTitle), 1)
                  ]),
                  (_ctx.article.body)
                    ? (_openBlock(), _createElementBlock("pre", {
                        key: 0,
                        style: {"margin":"0"},
                        innerHTML: _ctx.$marked(_ctx.article.body.slice(0,150))
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                "size-xs": "12",
                "size-sm": "1",
                "size-md": "1",
                "size-lg": "1",
                "size-xl": "1",
                size: "1",
                class: "flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_favourite_icon, {
                    articleId: _ctx.article.id,
                    style: {"margin":"0 0 0 auto"}
                  }, null, 8, ["articleId"])
                ]),
                _: 1
              }),
              (_ctx.article.videoURL)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    size: "12",
                    "size-sm": "6",
                    "size-md": "4",
                    "size-lg": "2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.article.videoURL)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    size: "12",
                    "size-sm": "5",
                    "size-md": "7",
                    "size-lg": "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.videocam,
                        style: {"position":"relative","top":"2px"}
                      }, null, 8, ["icon"]),
                      _createTextVNode("  " + _toDisplayString(_ctx.$t("articles.video")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}